// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__SvfQZ","choiceBoxes":"toolbarselects_choiceBoxes__AY1pv","simpleField":"toolbarselects_simpleField__1ODCD"};